const server = `https://${window["APP_HOST_SERVER"]}`;
const api = `${server}/api`;
const coreConfig = {
  ...window["configSite"],
  urls: {
    site: {
      config: `${api}/config/site/`,
    },
  },
};
export { coreConfig, server };
